import { createContext } from 'react';
import { MeetingAnalyticsData } from '../../../shared/types/types';
import INIT_MEETING_ANALYTICS_DATA from '../../../utils/analytics/analyticsDataObjects';

const
  MeetingAnalyticsDataContext = createContext<MeetingAnalyticsData>(INIT_MEETING_ANALYTICS_DATA);

export default MeetingAnalyticsDataContext;
